
import { ModuleFormData, ModuleFormSchema } from '../../types/form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import InputField from '../common/InputField';
// import { createUser, updateUser } from '@/actions/data-fetch-users';
import Button from '../common/Button';
import {CreateModuleRequest,ModulesDetail } from '../../types/settings/ModuleTypes';

import { createModule, updateModule } from '@/actions/data-fetch-modules';
import { toastMessage } from '@/utils/toast-message';
import Loader from '../common/Loader/Loader';


interface CreateNewModuleFormProps {
    onClose?: () => void; // Optional function to close the form
    uuid?: string; // Optional ID for updating existing roles
    initialData?: ModulesDetail | null;
    onSuccess?: (module: ModulesDetail) => void;
}

const CreateNewModuleForm = ({  onClose,uuid, initialData, onSuccess }: CreateNewModuleFormProps) => {
    // const navigate = useNavigate();
    // const [newrole,setnewrole]=useState();
    const [isSubmitting, setIsSubmitting] = useState(false);
    // Setting up form handling with react-hook-form and zod validation
    const { control, handleSubmit, formState: { errors }, setValue,watch } = useForm<ModuleFormData>({
        resolver: zodResolver(ModuleFormSchema),
        defaultValues: { module_name: '' },
    });


      useEffect(() => {
        console.log("Initial Data:", initialData);
            if (initialData) {
                setValue('module_name', initialData.module_name || '');
               
    
             
            }
        }, [initialData, setValue]);

         const transformFormToApiData = (formData: ModuleFormData): CreateModuleRequest => ({
            
                module_name: formData.module_name,
              
            });
            const onSubmit = async (formData: ModuleFormData) => {
                // setIsSubmitting(true);
                try {
                   
                    const apiData = transformFormToApiData(formData);
                    console.log("here");
                    console.log(apiData);
                    let response;
                    if (uuid) {
                        response = await updateModule(uuid, apiData);
                       
                    } else {
                        response = await createModule(apiData);

                        
                    }
            
                    if (response.status === 'success') {
                        // const columns = {
                        //     uuid: apiData.columns_uuid,
                        //     col_name: initialData?.columns?.col_name || 'columns'
                        // };
            
                        const updatedModule: ModulesDetail = {
                            ...initialData as ModulesDetail,
                            module_name: apiData. module_name,
                            
                        };
            
                        onSuccess?.(updatedModule);
                    } else {
                        // If response status is not success, throw the error message
                        throw response;
                    }
                }
                 catch (error: unknown) {
                    let errorMessage = "An unknown error occurred";
                
                    if (error instanceof Error) {
                        errorMessage = error.message;
                    } else if (typeof error === "string") {
                        errorMessage = error; // If error is a string, use it directly
                    } else if (typeof error === "object" && error !== null && "message" in error) {
                        errorMessage = String(error.message); // Ensure it's a string
                    }
                
                    toastMessage(errorMessage, 'error');
                }
                finally {
                    setIsSubmitting(false);
                }
            };
        
            if (isSubmitting) {
                return (
                    <div className="flex items-center justify-center z-40" style={{ height: '100vh' }}>
                        <Loader text={uuid ? 'Updating User...' : 'Creating User...'} withBackdrop={true} />
                    </div>
                );
            }
        
            // Add a debug handler to check form submission
            const handleFormSubmit = () => {
                console.log('Form Submit Event Triggered');
                console.log('Current Form Values:', watch());
            };
            return (
                <div>
                    <form onSubmit={handleSubmit(onSubmit)}
                        onSubmitCapture={handleFormSubmit} className="p-4">
                        {/* Form fields remain the same as in your original implementation */}
                        <div className="space-y-4">
                            {/* Input fields (same as previous implementation) */}
                            <InputField
                                className="lg:flex lg:flex-row flex-col lg:items-center bg-gray-100 px-3 py-1 dark:bg-gray-800"
                                label="Module Name"
                                id="moduleName"
                                name="module_name"
                                type="text"
                                control={control}
                                error={errors.module_name?.message}
                                required
                                labelClass="lg:w-1/5"
                            />
                           
        
                           
                         <div className="fixed bottom-5 right-3">
                            <hr className="ml-3 w-full" />
                            <div className="flex gap-5 mt-2 place-self-end">
                                <Button
                                    btnStyle="ghost"
                                    className="px-5 py-1"
                                    onClick={onClose}
                                    type="button"
                                    disabled={isSubmitting}
                                >
                                    Close
                                </Button>
        
                                <Button
                                    btnStyle="brandBtn"
                                    className="px-5 py-1"
                                    type="submit"
                                    onClick={(e) => {
                                        console.log('Button Clicked');
                                        // Manually trigger form validation
                                        handleSubmit(onSubmit)(e);
                                    }}
                                >
                                    {uuid ? 'Update' : 'Save'}
                                </Button>
        
                            </div>
                            </div>
                        </div>
                    </form>
                </div>
            );
        };
        
        export default CreateNewModuleForm;